import React, { Component } from "react";
import {MessageBarType, PrimaryButton} from "office-ui-fabric-react/lib-commonjs";
import Actions from "../../../redux/Actions";
import DispatchProps from "../../../utils/DispatchProps";
import {connect} from "react-redux";
import {IRootState} from "../../../store";
import ApiService from "../../ApiService";
import H from "history";

interface MoveToNextOnboardStateProps {
    tenantId: string;
    schoolCode: string;

    helpText: string;
    buttonText: string;
    
    apiService: ApiService;
    history: H.History;
}

interface MoveToNextOnboardStateState {
    isUpdatingState: boolean;
}

class MoveToNextOnboardState extends Component<MoveToNextOnboardStateProps & DispatchProps, MoveToNextOnboardStateState> {

    constructor(props: MoveToNextOnboardStateProps & DispatchProps) {
        super(props);
        this.state = {
            isUpdatingState: false
        };
    }

    private async moveToNextState(): Promise<boolean>  {
        try {
            await this.props.apiService.moveToNextOnboardingState(this.props.tenantId, this.props.schoolCode);
            
            //clear school cache
            await this.props.apiService.getSchool(this.props.tenantId,this.props.schoolCode,true);
            await this.props.apiService.getSchoolAdmin(this.props.tenantId,this.props.schoolCode,true);
            
            await this.props.dispatch(Actions.showMessageBar(`Successfully updated state.`, MessageBarType.success));
            this.props.history.push(`/manage/${this.props.tenantId}/${this.props.schoolCode}/onboard`);
            return true;
        } catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Failed to set onboarding state : ${e.message}`, MessageBarType.error));
            return false;
        }
    }

    private onButtonClick = async (): Promise<void> => {
        this.setState({ isUpdatingState: true });
        await this.moveToNextState();
        this.setState({ isUpdatingState: false });
    }

    public render(): JSX.Element {
        return (
            <div className="onboard-timeline-content">
                <div className="onboard-timeline-content-center">
                    {this.props.helpText}
                </div>
                <div className="onboard-timeline-content-center">
                    <PrimaryButton
                        disabled={this.state.isUpdatingState}
                        onClick={this.onButtonClick}
                        text={this.props.buttonText} />
                </div>
            </div>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: any): MoveToNextOnboardStateProps => {
        return {
            tenantId: ownProps.tenantId,
            schoolCode: ownProps.schoolCode,
            helpText: ownProps.helpText,
            buttonText: ownProps.buttonText,
            
            apiService: state.auth.apiService,
            history: ownProps.history
        };
    }
)(MoveToNextOnboardState);